import React, { useEffect, useState } from 'react';
import Tools from '../../../cvp-webgames-core/Misc/Tools';
import { constants } from '../../../misc/constants';
import { setFocus } from '../../../misc/tools';
import { BaseConfig } from '../../BaseConfig';
import GeneralButtonWithText from '../../helpers/GeneralButtonWithText';
import { UIProperties } from '../../UIProperties';
import ToolbagUI from '../ToolbagUI';
import VortexUI from './VortexUI';

export enum HudActions {
	AdjustBedHeight,
	CallForFiberopticLaryngoscope,
	PreOxygenatePatient,
	// PositionPatient,
	SetupSuction,
	AdministerMedications,
	RepeatSbarInformation,
	AssessAirway,
	VortexAid,
	CallForVortex,
	CallForOORAM
}

export enum HudNPCType {
	respiratoryTherapist,
	nurse,
	physician,
	patient
}

var selectedName = '';
var disabledActions: HudActions[] = [];

const handle508ClickOut = (name?: string)=> {
	var id = (name ?? selectedName) + 'hud-root-button';
	// setFocus(id);
}

var patientSelected = false;
var displayVortex = false;

const HUDUI = (props: UIProperties<HUDUIConfig>) => {
	const [showVortex, setShowVortex] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);
	const [selectedCharacterData, setSelectedCharacterData] = useState(null);
	const [selectedCharacterImg, setSelectedCharacterImg] = useState(null);
	const idleBgImage1 = './assets/images/HUD/buttons/button_header_1_main.png';
	const hoverBgImage1 = './assets/images/HUD/buttons/button_header_1_down.png';
	const idleBgImage2 = './assets/images/HUD/buttons/button_header_2_main.png';
	const hoverBgImage2 = './assets/images/HUD/buttons/button_header_2_down.png';

	const maleNurseIconMain = './assets/images/HUD/people/icon_nurse_male_main.png';
	const maleNurseIconDown = './assets/images/HUD/people/icon_nurse_male_down.png';
	const femaleNurseIconMain = './assets/images/HUD/people/icon_nurse_female_main.png';
	const femaleNurseIconDown = './assets/images/HUD/people/icon_nurse_female_down.png';

	const patientIconMain = './assets/images/HUD/people/icon_patient_main.png';
	const patientIconDown = './assets/images/HUD/people/icon_patient_down.png';

	const showOORam = () => {
		return constants.isLite && (window as any)['isCric'];
	}
	
	(window as any)["onCallForVortexClicked"] = () => {
		setShowVortex(true);
		displayVortex = true;
		if(props.parameters.onActionClicked) {
			props.parameters.onActionClicked(HudActions.CallForVortex, null, null);
		}
	}

	const onGeneralActionClicked = (icon: string, title: string, action: HudActions) => {
		if(props.parameters.onActionClicked(action, icon, title)) {
			var disableCallbacks = props.parameters.actionsDisableCallbacks ? props.parameters.actionsDisableCallbacks.filter(a => a.action === action) : [];
			if(disableCallbacks.length === 0) {
				disabledActions.push(action);
			} else {
				disableCallbacks[0].callback(() => {
					disabledActions.push(action);
				})
			}
		}
	}

	const actions = {
		adjustBedHeight: {
			title: 'Adjust Head of Bed',
			type: HudActions.AdjustBedHeight,
			onClick: (icon: string, title: string) => {
				onGeneralActionClicked(icon, title, HudActions.AdjustBedHeight);
			}
		}, 
		callForFiberopticLaryngoscope: {
			title: 'Call For Advanced Airway Cart',
			type: HudActions.CallForFiberopticLaryngoscope,
			onClick: (icon: string, title: string) => {
				onGeneralActionClicked(icon, title, HudActions.CallForFiberopticLaryngoscope);
			}
		},
		preOxygenatePatient: {
			title: 'Pre-Oxygenate Patient',
			type: HudActions.PreOxygenatePatient,
			onClick: (icon: string, title: string) => {
				onGeneralActionClicked(icon, title, HudActions.PreOxygenatePatient);
			}
		},
		// positionPatient: {
		// 	title: 'Position Patient',
		// 	onClick: (icon: string, title: string) => props.parameters.onActionClicked(HudActions.PositionPatient, icon, title)
		// },
		setupSuction: {
			title: 'Setup Suction',
			type: HudActions.SetupSuction,
			onClick: (icon: string, title: string) => {
				onGeneralActionClicked(icon, title, HudActions.SetupSuction);
			}
		},
		administerMedications: {
			title: 'Administer Medications',
			type: HudActions.AdministerMedications,
			onClick: (icon: string, title: string) => {
				onGeneralActionClicked(icon, title, HudActions.AdministerMedications);
			}
		},
		repeatSbarInformation: {
			title: 'Repeat SBAR Information',
			type: HudActions.RepeatSbarInformation,
			onClick: (icon: string, title: string) => {
				if(props.parameters.onActionClicked(HudActions.RepeatSbarInformation, icon, title)){
				}
			}
		},
		assessAirway: {
			title: 'Assess Airway',
			type: HudActions.AssessAirway,
			onClick: (icon: string, title: string) => {
				onGeneralActionClicked(icon, title, HudActions.AssessAirway);
			}
		},
		vortexAid: {
			title: 'Vortex Aid',
			type: HudActions.VortexAid,
			onClick: (icon: string, title: string) => {
				if(props.parameters.onActionClicked(HudActions.VortexAid, icon, title)){
				}
			}
		},
		callForOORAM: {
			title: 'Call for OORAM Level 3 provider / EMS',
			type: HudActions.CallForOORAM,
			onClick: (icon: string, title: string) => {
				onGeneralActionClicked(icon, title, HudActions.CallForOORAM);
			}
		}
	};
	
	const characterData = {
		respiratoryTherapist: {
			name: 'respiratoryTherapist',
			type: HudNPCType.respiratoryTherapist,
			menu: showOORam() ? [
				actions.adjustBedHeight,
				actions.callForFiberopticLaryngoscope,
				actions.preOxygenatePatient,
				actions.callForOORAM,
				actions.setupSuction
			] : [
				actions.adjustBedHeight,
				actions.callForFiberopticLaryngoscope,
				actions.preOxygenatePatient,
				// actions.positionPatient,
				actions.setupSuction
			]
		},
		nurse: {
			name: 'nurse',
			type: HudNPCType.nurse,
			menu: showOORam() ? [
				actions.adjustBedHeight,
				actions.administerMedications,
				actions.callForFiberopticLaryngoscope,
				actions.preOxygenatePatient,
				actions.callForOORAM,
				actions.repeatSbarInformation,
				actions.setupSuction
			] : [
				actions.adjustBedHeight,
				actions.administerMedications,
				actions.callForFiberopticLaryngoscope,
				actions.preOxygenatePatient,
				// actions.positionPatient,
				actions.repeatSbarInformation,
				actions.setupSuction
			]
		},
		physician: {
			name: 'physician',
			type: HudNPCType.physician,
			menu: showOORam() ? [
				actions.adjustBedHeight,
				actions.administerMedications,
				actions.callForFiberopticLaryngoscope,
				actions.preOxygenatePatient,
				actions.callForOORAM
			] : [
				actions.adjustBedHeight,
				actions.administerMedications,
				actions.callForFiberopticLaryngoscope,
				actions.preOxygenatePatient,
				// actions.positionPatient
			]
		},
		patient: {
			name: 'patient',
			type: HudNPCType.patient,
			menu: [
				actions.assessAirway,
				// actions.positionPatient
			]
		},
		vortex: {
			name: 'vortex',
			menu: [
				actions.vortexAid
			]
		}
	};

	const formatScore = (score: number) => {
		return score.toLocaleString();
	}
	const getDropdownMenuLeftPosition = () => {
		if(selectedName === characterData.respiratoryTherapist.name) {
			return 270;
		} else if(selectedName === characterData.nurse.name) {
			return 381;
		} else if (selectedName === characterData.physician.name) {
			return 503;
		}else if (selectedName === characterData.patient.name) {
			return 622;
		} else if(selectedName === characterData.vortex.name) {
			return 742;
		}
		return 0;
	}
	const renderCharacterData = () => {
		var data = selectedCharacterData as ActionConfig[];
		return (
			<div style={{
				position: 'absolute',
				left: getDropdownMenuLeftPosition() + 'px',
				top: '150px',
				width:  showOORam() ? '335px' : '293px'
			}}>
				<div className="modal-disable-select" style={{
					border: '3px solid rgb(192, 161, 6)',
					backgroundColor: 'rgb(36, 36, 36)',
					paddingTop: '12px',
					paddingLeft: '12px',
					paddingBottom: '12px',
					pointerEvents: 'all'
				}}>
					{data.map((o: ActionConfig, i: number) => {
						var isDisabled = (props.parameters.disabledActions && props.parameters.disabledActions.indexOf(o.type) !== -1) || disabledActions.indexOf(o.type) !== -1;
			
						return (
							<div style={{
								position: 'relative',
								height: '30px',
								pointerEvents: isDisabled ? 'none' : 'all'
							}} key={Tools.generateGuid()}>
								<GeneralButtonWithText parameters= {{
									text: o.title,
									top: '0',
									left: '0',
									width: showOORam() ? '310px' : '260px',
									isDisabled: isDisabled,
									srcIdle: null,
									srcHighlight: null,
									ariaLbl: o.title,
									id: 'hud-item' + i,
									customMainStyle: {
										// position: 'relative'
										width: showOORam() ? '310px' : '260px', 
										height: '100%',
										pointerEvents: 'all'
									},
									customButtonStyle: {
										width: '100%',
										height: '100%'
									},
									customTextStyle: {
										color: isDisabled ? 'rgba(255,255,255, 0.5)' : 'white',
										textAlign: 'left',
										fontSize: '13pt',
										pointerEvents: 'none',

									},
									onClicked: () => {
										selectedCharacterData[i].wasSelected = true;
										if(o.onClick) {
											o.onClick(selectedCharacterImg, selectedName);
										}
										setSelectedCharacterData(null);
									}
								}}/>
							</div>
						);
					})}
				</div>
			</div>
			
		);
	}
	useEffect(() => {
		(props.parameters as any).onForceUpdate = () => {
			setForceUpdate(!forceUpdate);
		}
	})

	const handleClickOut = (onDone: () => void) => {
		patientSelected = false;

		setTimeout(() => {
			var onClick = () => {
				patientSelected = false;
				handle508ClickOut();
				setSelectedCharacterData(null);
				window.removeEventListener('click', onClick);
			};
			window.addEventListener('click', onClick);
			onDone();
		}, 100);
	}

	const isNPCDisabled = (type: HudNPCType) => {
		return props.parameters.disabledNPCs && props.parameters.disabledNPCs.filter((npcType: HudNPCType) => npcType === type).length > 0;
	}
	return (
		<div style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<img tabIndex={0} id='hud-logo-root' aria-label='Difficult Airway algorithm and rescue cricothyrotomy logo' style={{
				position: 'absolute',
				top: '10px',
				left: '-50px',
				width: '340px'
			}} src="./assets/images/HUD/logo.png" />
			<p tabIndex={0} aria-label={'Score. ' + formatScore(props.parameters.score) + ' out of ' + formatScore(props.parameters.maxScore)} style={{
				position: 'absolute',
				top: '116px',
				left: '89px',
				fontSize: '8pt',
				margin: '0',
				width: '120px',
				textAlign: 'center'
			}} className='title-font'><span>{formatScore(props.parameters.score)}</span> / <span>{formatScore(props.parameters.maxScore)}</span></p>
			{/* <div style={{
				position: 'absolute',
				top: '42px',
				left: '204px',
				gridTemplateColumns: '117px 117px 117px 117px' + (showVortex ? ' 117px' : ''),
    			display: 'grid'
			}}> */}
				<CustomHUDButton 
					idleBackgroundImg={idleBgImage1}
					hoverBackgroundImg={hoverBgImage1}
					idleForegroundImg={maleNurseIconMain}
					hoverForegroundImg={maleNurseIconDown}
					isDisabled={isNPCDisabled(HudNPCType.respiratoryTherapist)}
					id={characterData.respiratoryTherapist.name + 'hud-root-button'}
					top={'42px'}
					left={(204 + 0) + 'px'}
					text='Respiratory Therapist'
					onClicked={() => {
						handleClickOut(() => {
							selectedName = characterData.respiratoryTherapist.name;
							setSelectedCharacterData(characterData.respiratoryTherapist.menu);
							setSelectedCharacterImg(maleNurseIconDown);
							// setTimeout(() => {
							// 	setFocus('hud-item0');
							// }, 1000);
						});
					}}/>
				{selectedName === characterData.respiratoryTherapist.name && selectedCharacterData ? renderCharacterData() : (null)}
				<CustomHUDButton 			
					idleBackgroundImg={idleBgImage2}
					hoverBackgroundImg={hoverBgImage2}
					idleForegroundImg={femaleNurseIconMain}
					hoverForegroundImg={femaleNurseIconDown}
					isDisabled={isNPCDisabled(HudNPCType.nurse)}
					top={'42px'}
					left={(204 + (120 * 1)) + 'px'}
					id={characterData.nurse.name + 'hud-root-button'}
					text='Nurse'
					onClicked={() => {
						handleClickOut(() => {
							selectedName = characterData.nurse.name;
							setSelectedCharacterData(characterData.nurse.menu);
							setSelectedCharacterImg(femaleNurseIconDown);
							// setFocus('hud-item0');
						});
					}}/>
				{selectedName === characterData.nurse.name && selectedCharacterData ? renderCharacterData() : (null)}
				<CustomHUDButton 
					idleBackgroundImg={idleBgImage2}
					hoverBackgroundImg={hoverBgImage2}
					idleForegroundImg={maleNurseIconMain}
					hoverForegroundImg={maleNurseIconDown}
					isDisabled={isNPCDisabled(HudNPCType.physician)}
					text='Physician'
					top={'42px'}
					left={(204 + (120 * 2)) + 'px'}
					id={characterData.physician.name + 'hud-root-button'}
					onClicked={() => {
						handleClickOut(() => {
							selectedName = characterData.physician.name;
							setSelectedCharacterData(characterData.physician.menu);
							setSelectedCharacterImg(maleNurseIconDown);
							// setFocus('hud-item0');
						});
						
					}}/>
				{selectedName === characterData.physician.name && selectedCharacterData ? renderCharacterData() : (null)}
				<CustomHUDButton 
					idleBackgroundImg={idleBgImage2}
					hoverBackgroundImg={hoverBgImage2}
					idleForegroundImg={patientIconMain}
					hoverForegroundImg={patientIconDown}
					isDisabled={isNPCDisabled(HudNPCType.patient)}
					id={characterData.patient.name + 'hud-root-button'}
					text='Patient'
					top={'42px'}
					left={(204 + (120 * 3)) + 'px'}
					onClicked={() => {
						handleClickOut(() => {
							if(!showVortex) {
								patientSelected = true;
							}
							selectedName = characterData.patient.name;
							setSelectedCharacterData(characterData.patient.menu);
							setSelectedCharacterImg(patientIconDown);
							// setFocus('hud-item0');
						});
						
					}}/>
				{selectedName === characterData.patient.name && selectedCharacterData ? renderCharacterData() : (null)}
				{showVortex ? <CustomHUDButton 
					idleBackgroundImg={idleBgImage2}
					hoverBackgroundImg={hoverBgImage2}
					idleForegroundImg={'./assets/images/HUD/people/icon_vortex_reader_main.png'}
					hoverForegroundImg={'./assets/images/HUD/people/icon_vortex_reader_down.png'}
					id={characterData.vortex.name + 'hud-root-button'}
					text='Vortex'
					top={'42px'}
					left={(204 + (120 * 4)) + 'px'}
					onClicked={() => {
						handleClickOut(() => {
							patientSelected = true;
							selectedName = characterData.vortex.name;
							setSelectedCharacterData(characterData.vortex.menu);
							setSelectedCharacterImg('./assets/images/HUD/people/icon_vortex_reader_down.png');
							// setFocus('hud-item0');
						});
						
					}}/> : (null)}
				{selectedName === characterData.vortex.name && selectedCharacterData ? renderCharacterData() : (null)}
			{/* </div> */}

			<GeneralButtonWithText parameters= {{
				text: 'Monitor',
				id:'monitor-ui-monitor-button',
				top: '45px',
				left: '1613px',
				width: '140px',
				isDisabled: false,
				srcIdle: "./assets/images/main-menu/button_menu_exit.png",
				srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
				srcDisabled: null,
				customImgStyle: {
				},
				customButtonStyle : {
				},
				customTextStyle: {
					fontSize: '12pt'
				},
				onClicked: () => {
					if((window as any).onMonitorButtonClicked) {
						(window as any).onMonitorButtonClicked();
					}
				}
			}}/>
			<div style={{
				position: 'absolute',
				top: '42px',
				right: '10px',
				gridTemplateColumns: '87px 94px',
    			display: 'grid'
			}}>
				 {/*<CustomHUDButton 
					idleBackgroundImg={idleBgImage2}
					hoverBackgroundImg={hoverBgImage2}
					isFlipped={true}
					top= {'0'}
					left= {'0'}
					idleForegroundImg={'./assets/images/HUD/icon_options_main.png'}
					hoverForegroundImg={'./assets/images/HUD/icon_options_down.png'}
					text='Options'
					id={'options-hud-root-button'}
					onClicked={() => {
						
					}}/> */}

				
				<CustomHUDButton 
					top= {'0'}
					left= {'90px'}
					idleBackgroundImg={idleBgImage1}
					hoverBackgroundImg={hoverBgImage1}
					isFlipped={true}
					idleForegroundImg={'./assets/images/HUD/icon_exit_main.png'}
					hoverForegroundImg={'./assets/images/HUD/icon_exit_down.png'}
					id={'exit-hud-root-button'}
					text='Exit'
					onClicked={() => {
						if(props.parameters.onExitClicked) {
							props.parameters.onExitClicked();
						}
					}}/>
			</div>

			<Custom508Control1></Custom508Control1>
			<ToolbagUI parameters={null} dispatch={null} id={null} key={null}></ToolbagUI>
			{/* {selectedCharacterData ? (
				<div style={{
					position: 'absolute',
					left: getDropdownMenuLeftPosition() + 'px',
					top: '150px',
					width:  showOORam() ? '335px' : '293px'
				}}>
					{renderCharacterData()}
				</div>
			) : (null)} */}
		</div>
	);
};

const Custom508Control1 = () => {
	const [forceUpdate, setForceUpdate] = useState(false);

	(window as any).onForceMuteButtonRerender = () => {
		setForceUpdate(!forceUpdate);
	}

	return (
		(window as any).onRenderMuteToggle()
	);

};

const CustomHUDButton = (props: CustomHUDButtonConfig) => {
	const [isSelected, setIsSelected] = useState(false);
	return (
		<div style={{
			position: 'absolute',
			top: props.top,
			left: props.left,
			width: '125px',
			height: '105px',
			pointerEvents: props.isDisabled ? 'none' : 'all',
			opacity: props.isDisabled ? 0.5 : 1
		}}>
			<GeneralButtonWithText parameters= {{
				text: '',
				top: '0px',
				left: '0px',
				ariaLbl:props.text,
				width: props.isFlipped ? '99px' : '132px',
				id: props.id,
				srcIdle: props.idleBackgroundImg,
				srcHighlight: props.hoverBackgroundImg,
				srcDisabled: props.idleBackgroundImg,
				isDisabled: props.isDisabled,
				customMainStyle: {
					position: 'relative',
					width: props.isFlipped ? '99px' : '129px',
					transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
				},
				onClicked: () => {
					props.onClicked();
					setIsSelected(!isSelected);
				},
				onPressAndHold: () => {
					setIsSelected(!isSelected);
				},
				onMouseOut: () => {
					setIsSelected(false);
				}
			}}/>
			<img style={{
				position: 'absolute',
				top: '5px',
				left: props.isFlipped ? '33px' : '40px',
				width: props.isFlipped ? '43px' : '53px',
				height: '55px',
				pointerEvents: 'none'
			}} src={isSelected ? props.hoverForegroundImg : props.idleForegroundImg} />
			<div style={{
				position: 'absolute',
				left: props.isFlipped ? '10px' : '40px',
				top: props.isFlipped ? '49px' : '69px',
				width: props.isFlipped ? '56px' : '75px',
				height: '18px',
				pointerEvents: 'none'
			}}>
				<div style={{
					position: 'relative',
					top: props.text === 'Respiratory Therapist' ? '-5px' : '0'
				}}>
					<p className='title-font' style={{
						textAlign: 'center',
						margin: '0',
						fontSize:  '8pt',
						fontWeight: 'normal'
					}}>{props.text}</p>
				</div>
				
			</div>
			
		</div>
	);

};

interface ActionConfig {
	title: string;
	wasSelected: boolean;
	type: HudActions;
	onClick: (selectedCharacterImg: string, title: string) => void;
}

interface HUDDropdownMenuConfig {
	options: ActionConfig[];
}

interface CustomHUDButtonConfig {
	text: string;
	id: string;
	top: string;
	left: string;
	idleBackgroundImg: string;
	hoverBackgroundImg: string;
	idleForegroundImg: string;
	hoverForegroundImg: string;
	isFlipped?: boolean;
	isDisabled?: boolean;
	onClicked: () => void;
}

//this is used to disable actions on command
export interface ActionDisableCallback {
	action: HudActions;
	callback: (disableCallback: () => void) => void;
}

export interface HUDUIConfig extends BaseConfig{
	score?: number;
	maxScore?: number;
	disabledActions?: HudActions[];
	disabledNPCs?: HudNPCType[];
	actionsDisableCallbacks?: ActionDisableCallback[];
	onActionClicked?: (actionType: HudActions, personIconDown: string, title: string) => boolean;
	onExitClicked?: () => void;
}

export default HUDUI;